import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_brand_values_sustainable: FaireCategoryEntity = {
  token: "cat_brand-values-sustainable",
  type: "category",
  name: "Sustainable",
  level: 2,
  parentToken: "cat_brand-values",
  href: "/category/sustainable",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
